<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    :title="title"
    @shown="onModalOpened"
    @hidden="shown = false"
    size="xl">
    <and-or 
      :options="options"
      :enable-rule-name="true"
      :disable-groups="true"
      :disable-or="true"
      :isFirst="true"
      :isComputedExpression="true"
      :isHidableRule="true"
      :group="group"
      :gridId="gridId"
      ref="filtersBuilder"></and-or>
      <div>
        <b-button @click="apply()">
          <span>Apply filters</span>
        </b-button>
      </div>
  </b-modal>
</template>

<script>
import * as eventsBusHolder from '@/helpers/events-bus-holder'
import AndOr from './../../PivotGrid/FilterBuilder/AndOR'

export default {
  props: {
    gridId: {
      type: String,
    },
    widgetKey: {
      type: String
    },
    group: {
      type: Object
    }
  },
  components: { AndOr },
  data () {
    return {
      shown: false,
      eventsHolder: eventsBusHolder.createHolder(),
      options: {
        dataProvider: this.gridId,
        keys: [],
        operators: [{
          name: 'contains',
          id: 'contains',
          except: ['lookup', 'date', 'checkbox']
        },{
          name: 'more',
          id: '<',
          except: ['lookup', 'date', 'checkbox']
        },{
          name: 'equal',
          id: '=',
          except: [ 'date', 'checkbox']
        },
        ,{
          name: 'not equal',
          id: '!=',
          except: [ 'date', 'checkbox']
        },{
          name: 'less',
          id: '>',
          except: ['lookup', 'date', 'checkbox']
        },{
          name: 'IN',
          id: 'in',
          onlyFor: ['lookup']
        },{
          name: 'Date',
          id: 'date',
          onlyFor: ['date']
        },{
          name: 'Checkbox',
          id: 'checkbox',
          onlyFor: ['checkbox']
        }]
      },
    }
  },
  computed: {
    title () {
      return `Filters Builder`
    }
  },
  methods: {
    openModal () {
      if (this.$refs.modal) {
        this.$refs.modal.show();
      }
    },
    closeModal () {
      if (this.$refs.modal) {
        this.$refs.modal.hide()
      }
    },
    onModalOpened () {
      this.shown = true
    },
    apply() {
      const statement = this.$refs.filtersBuilder.queryFormStatus();
      this.$emit('save', statement);
      this.closeModal();
    }
  },
  created () {
    this.eventsHolder.$on(`showFilterBuilder${this.widgetKey}-${this.gridId}`, (data) => {
      this.options.keys = [{
          name: 'Choose Key',
          id: -1
        }, 
        ...((data.keys || []).map(id => ({ name: id, id})))
      ];
      this.openModal();
    });
  },
  mounted () {
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    this.eventsHolder.clear();
    if (this.$refs.modal) {
      $(this.$refs.modal['$el']).remove()
    }
  }
}
</script>
